import { string } from "yup";

import { useContextConsumer } from "modules/context/Providers/ContextProvider";

import { validationMessages } from "./validationMessages";

export const useRecaptchaValidationSchema = () => {
  const { isRecaptchaDisabled } = useContextConsumer();

  if (isRecaptchaDisabled) {
    return string().nullable();
  }

  return string().required(validationMessages.requiredField).nullable();
};
